module.exports = __webpack_public_path__ + "img/raffle-badge.da445c79.png";